import { useMemo } from "react";
import { TransTokens } from "../../i18n/trans-tokens";
import { useScene } from "./use-scene";

const greatTokensSource = TransTokens.create({
  one: "Excellent!",
  two: "Great!",
  three: "Awesome!",
  four: "Doing good!",
  five: "Here, take some points!",
  six: "You are doing great!",
  seven: "Stunning performance!",
});

export const greatTokens = Object.values(greatTokensSource);

const mehTokensSource = TransTokens.create({
  one: "You can do better!",
  two: "We believe in you!",
  three: "Don't give up!",
  four: "It's the process that matters!",
  five: "You're great, but not the best!",
  six: "Keep on trying!",
  seven: "Aaaaahhw!",
});

export const mehTokens = Object.values(mehTokensSource);

export const usePointsQuote = () => {
  const { weight, totalPoints, maxPoints, isAnswered } = useScene();

  return useMemo(() => {
    if (!isAnswered) return null;
    const performedBadly = totalPoints < maxPoints * 0.66;
    const tokens = performedBadly ? mehTokens : greatTokens;

    const index = weight % tokens.length;

    return tokens[index];
  }, [isAnswered]);
};
